import { capitalize } from 'lodash';

import { IconBadgeValidated, IconBadgeCertified, IconBadgeVerified } from '@/components/Svg/Images';

import { type ICertificateType } from '../model';

type Props = {
  items: {
    label: string;
    value: string;
  }[];
  type: ICertificateType;
};

const badgeMap: {
  [key in ICertificateType]: React.ElementType;
} = {
  validated: IconBadgeValidated,
  verified: IconBadgeVerified,
  certified: IconBadgeCertified,
};

const Details = ({ items, type }: Props) => {
  const IconBadge = badgeMap[type];

  return (
    <div className="text-2xs text-foreground">
      {items.map(({ label, value }, index) => (
        <div className="flex items-center gap-1 min-h-6.5" key={index}>
          <strong className="font-bold w-24">{label}:</strong>
          <span>{value}</span>
        </div>
      ))}
      <div className="flex items-center gap-1 min-h-6.5">
        <strong className="font-bold w-24">Level achieved:</strong>
        <span className="flex items-center gap-1">
          <IconBadge className="size-4" /> {capitalize(type)}
        </span>
      </div>
    </div>
  );
};

export default Details;
